import { useEffect, useState } from 'react';
import { isPlatformAdmin, resolveProfile, type ProfileUser } from './profileIdentity';
import type { SidebarView } from '../components/layout/sidebarRegistry';

const PREVIEW_ROLES: Partial<Record<SidebarView, string>> = {
 owner:'admin', sales:'sr_sales_manager', sales_executive:'coordinator',
 accountant:'accounts_approver', production:'production_manager', inventory:'store_keeper',
 procurement:'buyer', crm_operations:'operations_manager', lead_triage:'lead_triage_coordinator',
 qa_manager:'qa_manager', qa_inspector:'qc_inspector', dispatch_manager:'dispatch_manager',
 loader:'loader', security:'security', service_technician:'service_tech', hr:'hr',
 puf_operator:'production', packing_operator:'production', production_operator:'production',
 project:'project_manager', service:'service_manager', telecaller:'telecaller',
 lead_manager:'lead_manager', warehouse_executive:'warehouse_executive',
 accounts_executive:'accounts_executive', field_partner:'field_partner',
 field_executive:'field_executive', backend_staff:'backend_staff',
};

/** Presentation only. Never pass this identity to authentication or an API. */
export function previewIdentity(user: ProfileUser | null | undefined, view: string | null | undefined): ProfileUser | null {
 if (!user || resolveProfile(user) !== 'P18' || isPlatformAdmin(user) || !view || view === 'owner') return null;
 const role = PREVIEW_ROLES[view as SidebarView];
 if (!role) return null;
 return {role:{name:role},tenantId:user.tenantId,designation:view === 'packing_operator' ? 'Packing Operator' : role === 'production' ? 'PUF Operator' : undefined};
}
export function readProfilePreview(): string | null {
 try { return sessionStorage.getItem('aura-view-override'); } catch { return null; }
}
export function useProfilePreview(user: ProfileUser | null | undefined): ProfileUser | null {
 const [,changed]=useState(0);
 useEffect(()=>{
  const refresh=()=>changed(n=>n+1);
  window.addEventListener('aura:view-override:change',refresh);
  return ()=>window.removeEventListener('aura:view-override:change',refresh);
 },[]);
 return previewIdentity(user,readProfilePreview());
}
